var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdflogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2033_17694",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 75
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2033_17694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8594 41.3281H28.75V34.8438H32.5C33.319 34.8438 34.0055 34.5667 34.5595 34.0127C35.1136 33.4586 35.3906 32.7721 35.3906 31.9531V28.2031C35.3906 27.3841 35.1136 26.6976 34.5595 26.1436C34.0055 25.5895 33.319 25.3125 32.5 25.3125H25.8594V41.3281ZM28.75 31.9531V28.2031H32.5V31.9531H28.75ZM38.8281 41.3281H45.3906C46.1719 41.3281 46.849 41.0511 47.4219 40.497C47.9948 39.943 48.2812 39.2565 48.2812 38.4375V28.2031C48.2812 27.3841 47.9948 26.6976 47.4219 26.1436C46.849 25.5895 46.1719 25.3125 45.3906 25.3125H38.8281V41.3281ZM41.7188 38.4375V28.2031H45.3906V38.4375H41.7188ZM52.1094 41.3281H55V34.8438H58.9062V31.9531H55V28.2031H58.9062V25.3125H52.1094V41.3281ZM20.3125 59.375C19.0625 59.375 17.9688 58.9063 17.0312 57.9688C16.0938 57.0313 15.625 55.9375 15.625 54.6875V10.9375C15.625 9.6875 16.0938 8.59375 17.0312 7.65625C17.9688 6.71875 19.0625 6.25 20.3125 6.25H64.0625C65.3125 6.25 66.4063 6.71875 67.3438 7.65625C68.2813 8.59375 68.75 9.6875 68.75 10.9375V54.6875C68.75 55.9375 68.2813 57.0313 67.3438 57.9688C66.4063 58.9063 65.3125 59.375 64.0625 59.375H20.3125ZM10.9375 68.75C9.6875 68.75 8.59375 68.2813 7.65625 67.3438C6.71875 66.4063 6.25 65.3125 6.25 64.0625V15.625H10.9375V64.0625H59.375V68.75H10.9375Z",
    fill: "#B00041"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdflogo);
export default __webpack_public_path__ + "static/media/pdflogo.8863a7d4f7dabef97d3c3c816243d75c.svg";
export { ForwardRef as ReactComponent };